import { writable } from 'svelte/store';
import { fetchWithAuthentication } from "./api/client.js";

export const version = writable('');

export async function refreshVersion(context) {
    const response = await fetchWithAuthentication(
        context,
        "/get_model_version/",
        {}
    );
    version.set(response.version);
}